var exports = {
  "jw": "MessageThreadChip.module__chip___aVYtOE",
  "nM": "MessageThreadChip.module__row___aVYtOE",
  "UU": "MessageThreadChip.module__name___aVYtOE",
  "U9": "MessageThreadChip.module__count___aVYtOE",
  "VH": "MessageThreadChip.module__preview___aVYtOE",
};

module.exports = exports;
